import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const URL_BASE_USUARIOS_WEB =  `${API_URL}/administrador/usuariosweb`;
const BUSQUEDA_ALTA_USUARIOS_WEB = `${API_URL}/administrador/usuariosweb/buscadorAltaUsuario`;
const BUSQUEDA_MOD_USUARIOPASWD_USUARIOS_WEB = `${API_URL}/administrador/usuariosweb/buscadorModificarUsuario`;


export async function getBusquedaUsuariosBaja(valores, numPagina, tamano) {
    return await axios({
        // headers: { Authorization: `Bearer ${token}` },
        method: "POST",
        url: BUSQUEDA_ALTA_USUARIOS_WEB,
        data: valores,
        params: { pageNumber: numPagina, size: tamano }
    })
        .then((response) => response.data)
        .catch(
            (response) =>
                (response.data = "Error: Fallo en recoger los resumenes de Nomina")
        );
}
export async function getBusquedaModUsuarioPasswd(valores, numPagina, tamano) {
    return await axios({
        // headers: { Authorization: `Bearer ${token}` },
        method: "POST",
        url: BUSQUEDA_MOD_USUARIOPASWD_USUARIOS_WEB,
        data: valores,
        params: { pageNumber: numPagina, size: tamano }
    })
        .then((response) => response.data)
        .catch(
            (response) =>
                (response.data = "Error: Fallo en recoger los resumenes de Nomina")
        );
}

export async function darAltaUsuarioWeb(niep) {
    return await axios({
        // headers: { Authorization: `Bearer ${token}` },
        method: "GET",
        url: `${URL_BASE_USUARIOS_WEB}/${niep}/alta`,
    })
        .then((response) => response.data)
        .catch(
            (response) =>
                (response.data = "Error: Fallo al dar de alta al usuario")
        );
}

export async function cambiarNombreUsuario(nombreUsuario,dni) {
    return await axios({
        // headers: { Authorization: `Bearer ${token}` },
        method: "PUT",
        url: `${URL_BASE_USUARIOS_WEB}/${dni}/nombreUsuario`,
        data:{nombreUsuario:nombreUsuario}
    })
        .then((response) => response.data)
        .catch(
            (response) =>
                (response.data = "Error: Fallo al dar de alta al usuario")
        );
}


export async function cambiarPasswd(valores,dni) {
    return await axios({
        // headers: { Authorization: `Bearer ${token}` },
        method: "PUT",
        url: `${URL_BASE_USUARIOS_WEB}/${dni}/password`,
        data:{
            password:valores.nuevaPasswd,
            passwordValidacion:valores.confirmarPasswd
        }
    })
        .then((response) => response.data)
        .catch(
            (response) =>
                (response.data = "Error: Fallo al dar de alta al usuario")
        );
}